import $ from 'jquery';

class AjaxPosts {
  constructor() {
    this.filter = $('#filters');
    this.response = $('#response');

    this.filtering = false;

    this.search = this.filter.find('[name="kw"], [name="title"]');
    this.previousValue = undefined;
    this.typingTimer = undefined;

    this.reset = this.filter.find('.reset');

    this.paginationChanged = false;
    this.pScrollBuffer = 50;

    this.events();
    this.initFromUrl();
  }

  // --- Loading UI helpers ---
  showLoading() {
    // Clear previous content and show a spinner that's accessible
    this.response
      .removeClass('is-ready')
      .empty()
      .append(`
        <div id="ajax-spinner" class="spinner" role="status" aria-live="polite" aria-busy="true">
          <span class="sr-only">Loading…</span>
        </div>
      `);
  }

  hideLoading() {
    // Remove spinner if present
    this.response.find('#ajax-spinner').remove();
  }
  // ---------------------------

  resolveFilterValue(input, key, value) {
    if (!input.length || key !== 'l_cat') {
      return value;
    }

    if (input.find(`option[value="${value}"]`).length) {
      return value;
    }

    const lawyerValue = `lc-${value}`;
    if (input.find(`option[value="${lawyerValue}"]`).length) {
      return lawyerValue;
    }

    const peopleValue = `pc-${value}`;
    if (input.find(`option[value="${peopleValue}"]`).length) {
      return peopleValue;
    }

    return value;
  }

  initFromUrl() {
    if (window.location.search) {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.forEach((value, key) => {
        const input = this.filter.find(`[name="${key}"]`);
        if (input.length) {
          input.val(this.resolveFilterValue(input, key, value));
        }
      });
      this.doAjax();
    } else {
      // If no URL parameters, just show the default content
      this.response.addClass('is-ready');
    }
  }

  events() {
    this.filter.find('.filter__item').on('change', this.changeFilter.bind(this));
    this.filter.submit(e => this.processSubmit(e));

    // Keydown fires so fast, that it doesn't give the input enough time to update its value.
    this.search.on('keyup', this.typingLogic.bind(this));

    this.reset.on('click', this.resetFilter.bind(this));

    $(document).on('click', '#response .pagination a', e => this.changePage(e));
  }

  resetFilter() {
    // Set custom dropdowns to initial value
    let items = this.filter.find('.filter__item--reset');
    items.each(function () {
      let $this = $(this);
      $this.val('');
      const $customSelect = $this.closest('.select-services, .select-faq');
      if ($customSelect.length) {
        const $defaultItem = $customSelect.find('li[data-value=""]').first();
        const $label = $customSelect.find('.select-services__label, .select-faq__label').first();
        const $listItems = $customSelect.find('li');
        $listItems.removeClass('is-selected');
        if ($defaultItem.length) {
          $defaultItem.addClass('is-selected');
          if ($label.length) {
            const $anchor = $defaultItem.find('a');
            $label.text($anchor.length ? $anchor.text().trim() : $defaultItem.text().trim());
          }
        }
      }
    });
    this.filter.find('[name="pg"]').val(1);

    // Change filter
    setTimeout(this.changeFilter.bind(this), 0);
    return false;
  }

  typingLogic() {
    if (this.search.val() != this.previousValue && !this.filtering) {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(this.changeFilter.bind(this), 750);
    }
    this.previousValue = this.search.val();
  }

	changePage(e) {
	  e.preventDefault();
	
	  const $link = $(e.currentTarget); // always the <a>, not inner span/icon
	  const href  = $link.attr('href') || '';
	  const num   = href.split('#').pop();
	
	  if (num) {
	    this.filter.find('[name="pg"]').val(num);
	    this.paginationChanged = true;
	    this.doAjax();
	  }
	}
  changeFilter() {
    this.filter.find('[name="pg"]').val(1);
    setTimeout(this.doAjax.bind(this), 0);
  }

  processSubmit(e) {
    e.preventDefault();
    setTimeout(this.changeFilter.bind(this), 0);
  }

  doAjax() {
    const i = this.filter.serialize();
    if (this.filter && this.filter.length) {
      window.history.pushState('', '', '?' + i);
    }

    setTimeout(this.getResults.bind(this), 0);

    return false;
  }

  getResults() {
    if (this.filtering) return;

    $.ajax({
      url: window.themeData.ajax_url,
      data:
        this.filter.serialize() +
        '&nonce=' +
        window.themeData.ajax_nonce +
        '&action=process_ajax', // form data
      type: this.filter.attr('method'), // POST
      beforeSend: xhr => {
        this.filtering = true;
        this.response.parents('.section').addClass('loading');
        this.showLoading(); // clear #response and show spinner
      },
      success: response => {
        // Replace spinner with results
        this.response.html(response).addClass('is-ready');

        if (this.paginationChanged) {
          $('html').animate(
            {
              scrollTop:
                this.response.offset().top -
                $('.header__inner').innerHeight() -
                this.pScrollBuffer
            },
            800
          );
          this.paginationChanged = false;
        }
      },
      error: response => {
        // Optional: show an error message in #response
        this.response
          .empty()
          .append('<p class="notice notice--error">Sorry, something went wrong. Please try again.</p>');
        // Keep is-ready to avoid reapplying loading styles
        this.response.addClass('is-ready');
        // Still log for debugging
        console.log(response);
      },
      complete: () => {
        this.filtering = false;
        this.response.parents('.section').removeClass('loading');
        this.hideLoading(); // remove spinner on success or error
      }
    });
  }
}

export default new AjaxPosts();